namespace TR {
    class FiltersLabels { }

    angular
        .module('TR')
        .directive('filtersLabels', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=FiltersLabels',
                replace: true,
                bindToController: {
                    filters: '=',
                    aggregates: '=',
                    priceMode: '='
                },
                controller: FiltersLabels,
                controllerAs: 'fl'
            };
        });

}
